const aa = '';
export default aa;

export function getRandom(size) {
  return Math.floor(Math.random() * size + 1)
}

export function calcPlusUpLuck() {
  const plusUpLuck = [
    {up: '1',  success: '21', fail: '79', failZero: '0'},
    {up: '2',  success: '20', fail: '65', failZero: '15'},
    {up: '3',  success: '19', fail: '65.2', failZero: '15.8'},
    {up: '4',  success: '18.1', fail: '65.3', failZero: '16.6'},
    {up: '5',  success: '17.2', fail: '65.4', failZero: '17.4'},
    {up: '6',  success: '16.3', fail: '65.4', failZero: '18.3'},
    {up: '7',  success: '15.5', fail: '65.3', failZero: '19.2'},
    {up: '8',  success: '14.7', fail: '65.1', failZero: '20.2'},
    {up: '9',  success: '14', fail: '64.8', failZero: '21.2'},
    {up: '10', success: '13.3', fail: '64.4', failZero: '22.3'},
    {up: '11', success: '12.6', fail: '64', failZero: '23.4'},
    {up: '12', success: '12', fail: '63.4', failZero: '24.6'},
    {up: '13', success: '11.4', fail: '62.8', failZero: '25.8'},
    {up: '14', success: '10.8', fail: '62.1', failZero: '27.1'},
    {up: '15', success: '10.3', fail: '61.2', failZero: '28.5'}
  ];

  const plusUpLuckByValue = plusUpLuck.map(luck => {
    const {success, fail} = luck;

    return {
      ...luck,
      luck: {
        success: String(Number(success) * 10),
        fail: String((Number(fail)*10) + (Number(success)*10)),
        failZero: '1000'
      }
    }
  });

  return plusUpLuckByValue;
}

export function calcPlusUpGrid() {
  var base_value1 = 1.111111111;
  var base_value2 = 1.666666666;
  var base_value3 = 2.50;
  var value1_ary = [];
  var value2_ary = [];
  var value3_ary = [];
  var result_obj = {};
  var str_rt = 0.5;
  for(var i=0; i<11; i++) {
    var value = str_rt+(i*0.1);
    value1_ary.push((base_value1 * value));
    value2_ary.push((base_value2 * value));
    value3_ary.push((base_value3 * value));
  }
  
  result_obj.value1 = value1_ary;
  result_obj.value2 = value2_ary;
  result_obj.value3 = value3_ary;
  
  var real_result_list =[]
  var result_list = [];
  var list = [];
  var list_sub = [];
  var calc_value = 0;
  var armorr_ary = [1, 2, 6];

  for(var a=0; a<3; a++) {
    result_list = [];
    calc_value = 0;
    for(var j=0; j<3; j++) {
      list = [];
      calc_value = 0;
      for(var jj=2; jj<11; jj++) {
        list_sub = [];
        calc_value = 0;
        for(var jjj=0; jjj<15; jjj++) {
          if(jjj>=0 && jjj<=4) {
            calc_value = calc_value + Number(eval("value"+(j+1)+"_ary[jj]"));
          }else if(jjj>=5 && jjj<=9) {
            calc_value = calc_value + Number(eval("value"+(j+1)+"_ary[jj]")*2);
          }else{
            calc_value = calc_value + Number(eval("value"+(j+1)+"_ary[jj]")*3);
          }
  
          list_sub.push((calc_value*armorr_ary[a]).toFixed(2));
        }
        list.push(list_sub);
      }
      result_list.push(list);
    }
    real_result_list.push(result_list);
  }

  return real_result_list;
}